import styled from 'styled-components';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import { useHistory, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { RootState } from 'StoreModel';

import MicrosoftLoginButton from './MicrosoftLoginButton';
import GoogleLoginComponent from './GoogleLoginButton';
import React, { useEffect } from 'react';
import { googleSignIn } from 'redux/actions/session';
import { Email } from 'components/styled-components/common';

const LoginButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1em;
  width: 100%;
  align-items: center;

  iframe {
    margin: 0 auto !important;
  }
`;

const mapDispatchToProps = {
  googleSignIn: googleSignIn.request,
};

const mapStateToProps = (state: RootState) => ({
  literals: state.literals,
  bearer: state.account.session.session.bearer,
});

type dispatchType = typeof mapDispatchToProps;
interface Props extends ReturnType<typeof mapStateToProps>, dispatchType {
  setSignUpViaEmail: () => void;
}

const SignupComponent: React.FC<Props> = ({ googleSignIn, setSignUpViaEmail, literals, bearer }) => {
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const targetCommunityId = parseInt(queryParams.get('to') || '0');
  let targetCircleId: number | null = queryParams.get('circleId') ? parseInt(queryParams.get('circleId')!) : null;
  if (targetCircleId !== null && isNaN(targetCircleId)) {
    targetCircleId = null;
  }

  let targetTags: string[] | null = null;
  const tagsFromQuery = queryParams.get('tags');

  if (tagsFromQuery) {
    try {
      const decodedTags = decodeURIComponent(tagsFromQuery);

      const cleanedTags = decodedTags.replace(/'%27/g, "'").replace(/^\[|\]$/g, '');
      const tagArray = cleanedTags.split(',').map(tag => tag.trim().replace(/^'(.*)'$/, '$1'));

      if (Array.isArray(tagArray) && tagArray.every(tag => typeof tag === 'string')) {
        targetTags = tagArray;
      }
    } catch (error) {
      targetTags = null;
    }
  }

  useEffect(() => {
    if (bearer) {
      history.push('/community');
    }
  }, [bearer]);
  return (
    <LoginButtonsContainer>
      <GoogleLoginComponent
        googleSignIn={googleSignIn}
        targetCommunityId={targetCommunityId}
        targetCircleId={targetCircleId}
        targetTags={targetTags}
      />
      <MicrosoftLoginButton
        targetCommunityId={targetCommunityId}
        targetCircleId={targetCircleId}
        targetTags={targetTags}
      />
      <Email onClick={setSignUpViaEmail}>
        <MailOutlineIcon />
        <span>{literals.sign_in_with_email_text}</span>
      </Email>
    </LoginButtonsContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(SignupComponent);
